<script lang="ts" setup>
defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  error: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="flex flex-col">
    <div class="flex gap-3 items-center">
      <slot />
      <slot name="label" :label="label" :input-name="name">
        <label :for="name" class="text-left cursor-pointer">{{ label }}</label>
      </slot>
    </div>
    <span
      class="text-input-error c-text-error mt-1.5 text-small h-4.5 flex items-center"
      :class="{
        'select-none pointer-events-none opacity-0': !error,
      }"
    >
      {{ error }}
    </span>
  </div>
</template>
